'use client';
import { useState } from 'react';
import styles from './styles.module.scss';

const ServicesForm = props => {
    const {colorScheme} = props || {};
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(false);
    
        try {
          const response = await fetch('/api/demo_form', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              
            },
            body: JSON.stringify(formData),
          });
    
          if (!response.ok) {
            throw new Error('Failed to submit form');
          }
    
          const data = await response.json();
          setLoading(false);
          setError(false);
          setSubmitted(true);
        } catch (error) {
            setLoading(false);
            setError(true);
            setSubmitted(false);
        }
    };

    const renderError = () => {
        if(!error) return null;
        return(
            <div className={`${styles.servicesForm__error} form_error_message`}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00004 1.33334C4.32004 1.33334 1.33337 4.32001 1.33337 8.00001C1.33337 11.68 4.32004 14.6667 8.00004 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 8.00004 1.33334ZM7.33337 11.3333V10H8.66671V11.3333H7.33337ZM7.33337 4.66668V8.66668H8.66671V4.66668H7.33337Z" fill="#E8236B"/>
                </svg>

                <span>
                    There was an error with your form submission
                </span>
            </div>
        );
    }

    const renderCtaOrSuccessMessage = () => {
        if(!submitted) {
            return (
                <div className={styles.servicesForm__ctaRow}>
                    <button disabled={loading} className={`${styles.callout__cta} button large  ${colorScheme}`}>
                        Schedule My Demo
                    </button>
                </div>
            )
        } else {
            <div className={styles.servicesForm__ctaRow}>
                <div  className={styles.servicesForm__success}>
                    You have Successfully Submitted Your Request
                </div>
            </div>
        }
    }
    return(
        <form className={styles.servicesForm} onSubmit={handleSubmit}>
            {renderError()}
            <div>
                <fieldset className='fieldset'>
                    <label className={`label ${colorScheme}`}>First Name</label>
                    <input type="text" className={`input ${error ?  'input_error' : ''}`} onChange={handleChange} required />
                </fieldset>
                <fieldset className='fieldset'>
                    <label className={`label ${colorScheme}`}>Email</label>
                    <input type="text" className={`input ${error ?  'input_error' : ''}`} onChange={handleChange} required/>
                </fieldset>
            </div>
            <div>
                <fieldset className='fieldset'>
                    <label className={`label ${colorScheme}`}>Last Name</label>
                    <input type="text" className={`input ${error ?  'input_error' : ''}`} onAnimationEndCapturenChange={handleChange} required/>
                </fieldset>
                <fieldset className='fieldset'>
                    <label className={`label ${colorScheme}`}>Phone</label>
                    <input type="text" className={`input ${error ?  'input_error' : ''}`} onChange={handleChange} required />
                </fieldset>
            </div>
            {renderCtaOrSuccessMessage()}
            {/* <div className={styles.servicesForm__ctaRow}>
                <button className={`${styles.callout__cta} button large  ${colorScheme}`}>
                    Schedule My Demo
                </button>
            </div> */}
        </form>
    );
}

export default ServicesForm;